import { request } from './http';

export async function getResponseEquipmentInventoryPrefill(siteId) {
    return request(`/inspections/response-equipment/prefill?siteId=${encodeURIComponent(siteId)}`);
  }

export async function getResponseEquipmentInventoryEquipment(inspectionId) {
    return request(`/inspections/response-equipment/${inspectionId}/equipment`);
  }

export async function saveResponseEquipmentInventoryHeader(payload) {
    return request('/inspections/response-equipment/header', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

export async function saveResponseEquipmentInventoryEquipment(inspectionId, equipment) {
    return request(`/inspections/response-equipment/${inspectionId}/equipment`, {
      method: 'POST',
      body: JSON.stringify({ equipment }),
    });
  }

export async function generateResponseEquipmentInventoryPdf(recordId) {
    return request('/pdf/generate-and-save-response-equipment-inventory-inspection', {
      method: 'POST',
      body: JSON.stringify({ recordId }),
    });
  }

export async function saveTransferHosePipeTesting(data) {
    return request('/transfer-hose-pipe-testing', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export const responseEquipmentInventoryApi = {
  getResponseEquipmentInventoryPrefill,
  getResponseEquipmentInventoryEquipment,
  saveResponseEquipmentInventoryHeader,
  saveResponseEquipmentInventoryEquipment,
  generateResponseEquipmentInventoryPdf,
  saveTransferHosePipeTesting,
};

